const recipes = [
  {
    id: 1,
    title: "Asian Kale and Chickpea Salad",
    slug: "asian-kale-and-chickpea-salad",
    authorId: 1,
    recipeOwner: "",
    category: ["Dinner", "Lunch", "Salad"],
    difficulty: "3",
    steps: [
      "Combine miso with water and mix into paste",
      "Mix red chili flake, garlic powder, and maple syrup into the miso paste",
      "Mix chickpeas into the paste to marinade",
      "Ribbon/Thinly cut carrots",
      "Cut cabbage into thin ribbons",
      "Wash and massage kale",
      "In a bowl, combine cashew butter, liquid aminos (or tamari), lemon juice, sweetner, ginger powder, sesame oil, toasted sesame oil, rice vinegar, and apple cider vinegar (may get best results from blending)",
      "Broil chickpeas until browned",
      "Serve by mixing salad with dressing and placing broiled chickpeas on top. Finish by covering the dish in sesame seeds",
    ],
    prepTime: "45 min",
    cookTime: "5-15 min",
    notes:
      "This is a personal favorite. The chickpeas don't need to marinade too long but I think they usually taste better after marinading for at least 30 minutes.",
    ingredients: [
      ["chickpeas", "1-2 cups"],
      ["kale", "one bunch, chopped"],
      ["cabbage", "two handfuls, sliced"],
      ["carrots", "handful, sliced"],
      ["sesame seeds", "a lot"],
      ["lemon", "1/2"],
      ["rice vinegar", "dash"],
      ["sesame oil", "dash"],
      ["toasted sesame oil", "very small dash"],
      ["apple cider vinegar", "dash"],
      ["miso", "2 tablespoons"],
      ["agave", "dash"],
      ["ginger powder", "dash"],
      ["liquid aminos", "dash"],
      ["red chili flakes", "dash"],
      ["salt", "dash"],
      ["pepper", "dash"],
    ],
  },
  {
    id: 2,
    title: "Cashew Alfredo Sauce",
    slug: "cashew-alfredo-sauce",
    authorId: 1,
    recipeOwner: "",
    category: ["Sauce"],
    difficulty: "4",
    steps: [
      "Soak cashews in room temperature water for 4 hours (you can also soak them for one hour if you start but putting them in very hot water)",
      "Sautee onion and 1/2 of garlic",
      "Place sauteed onions and garlic in blender along with the cashews and water and blend",
      "Once blended smooth, add remaining ingredients to the sauce and blend more",
      "Taste and spice as needed",
    ],
    prepTime: "60 min",
    notes: "Paprika can sometimes add a nice flavor",
    ingredients: [
      [
        ["cashews", "1 cup"],
        ["yellow onion"],
        ["4+ cloves garlic"],
        ["nutritional yeast", "1/2 cup"],
        ["lemon", "1/2"],
        ["liquid smoke", "about 4 drops"],
        ["red chili flakes", "dash"],
        ["salt", "dash"],
        ["pepper", "dash"],
      ],
    ],
  },
  {
    id: 3,
    title: "Chia Pudding",
    slug: "chia-pudding",
    authorId: 1,
    recipeOwner: "5e634f1d6bf842370465b4d9",
    category: ["Dessert", "Breakfast"],
    difficulty: "2",
    steps: [
      "Put everything except the chia seeds into the blender and pulse",
      "Pour into container and immediately add chia seeds",
      "let sit in fridge for a few hours",
    ],
    prepTime: "10 min",
    notes:
      "Be sure to add the chia seeds IMMEDIATELY after pouring the pudding into its container. if you wait, strange things happen.",
    ingredients: [
      ["chia seeds", "1 cup"],
      ["cocao powder", "1/3 cup"],
      ["cinnamon", "dash"],
      ["nutmet", "dash"],
      ["vanilla", "1 tablespoon"],
      ["oat milk", "1 cup"],
      ["coconut milk", "1 cup"],
      ["maple syrup", "dash"],
    ],
  },
  {
    id: 4,
    title: "Delicata Squash and Kale Pasta",
    slug: "delicata-squash-and-kale-pasta",
    authorId: 1,
    recipeOwner: "5e6346b66bf842370465b4d5",
    category: ["Lunch", "Dinner", "Italian", "Noodles"],
    difficulty: "3",
    steps: [
      "Preheat oven to 450",
      "Cut squash in half",
      "Deseed squash",
      "Chop squash into bite sized chunks",
      "Mince red onion",
      "Mince garlic",
      "Mix squash, onion, garlic into mixing bowl with oil and spices",
      "bake for 25 minutes",
      "boil water for pasta",
      "chop kale",
      "once pasta is almost done, throw kale into the bowl (yes, put the kale into the bowl of pasta and hot pasta water)",
      "Let kale sit in water for about a minute and then drain",
      "return noodles and kale to bowl and mix in whatever sauce you're using",
      "when squash is done cooking, mix that in as well",
      "drizzle bowl with balsamic",
    ],
    prepTime: "45 min",
    cookTime: "30 min",
    notes:
      "I like this dish along with cashew alfredo sauce but it's also tastywith tomato sauce. I know it seems weird to put kale into hot pasta water, butjust do it.",
    ingredients: [
      ["Kale", "1-2 bunches, chopped"],
      ["Pasta", "a lot"],
      ["Delicata Squash"],
      ["red onion"],
      ["olive oil", "a lot"],
      ["cashew alfredo sauce"],
      ["garlic", "a lot"],
      ["red chili flakes", "dash"],
      ["salt", "dash"],
      ["pepper", "dash"],
    ],
  },
  {
    id: 5,
    title: "Instant Pot Black Beans",
    slug: "instant-pot-black-beans",
    authorId: 1,
    recipeOwner: "5e631c933a4ffe2cad37d1c2",
    category: ["Anytime"],
    difficulty: "1",
    steps: [
      "rinse beans",
      "soak beans for at least 8 hours",
      "put beans into instant pot along with spices",
      "cook for about 15 minutes",
      "allow instant pot to sit, still sealed, for 10 minutes after timer runs out before allowing steam out",
      "salt to taste",
    ],
    prepTime: "45 min",
    cookTime: "30 min",
    notes:
      "You can really prep as many black beans as you want, but be sure thatwhen you add them to the instant pot, you can still add enough water to cover beans (plus an inch or so) and have the water level be beneath the suggested height. Also use whatever spices sound good to you - the ones listed are tried and true but I often try new combinations",
    ingredients: [
      ["Black beans", "1-2 cups, rinsed"],
      ["garlic powder", "a lot"],
      ["onion powder", "a lot"],
      ["paprika", "dash"],
      ["smoked paprika", "dash"],
      ["salt", "dash"],
      ["dill", "dash"],
    ],
  },
];

const newRecipe = {
  _id: 123,
  title: "",
  slug: "",
  authorId: 1,
  recipeOwner: "",
  category: [],
  difficulty: "",
  steps: [],
  prepTime: "",
  cookTime: "",
  notes: "",
  ingredients: [],
  recipeAdmin: [],
  recipeAdminMap: [],
};

// Using CommonJS style export so we can consume via Node (without using Babel-node)
module.exports = {
  recipes,
  newRecipe,
};
